var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectGame")
                  },
                  on: { change: _vm.gamechangeManage },
                  model: {
                    value: _vm.searchData.game,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "game", $$v)
                    },
                    expression: "searchData.game"
                  }
                },
                _vm._l(_vm.searchgames, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.game_name, value: item.game_mark }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectPlatform")
                  },
                  on: { change: _vm.platformchangeManage },
                  model: {
                    value: _vm.searchData.platform,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "platform", $$v)
                    },
                    expression: "searchData.platform"
                  }
                },
                _vm._l(_vm.searchplatforms, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.platform_name,
                      value: item.platform_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectChannel")
                  },
                  on: { change: _vm.channelchangeManage },
                  model: {
                    value: _vm.searchData.channel,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "channel", $$v)
                    },
                    expression: "searchData.channel"
                  }
                },
                _vm._l(_vm.searchchannels, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.channel_name,
                      value: item.channel_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectDeliveryPackage")
                  },
                  model: {
                    value: _vm.searchData.pkg,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "pkg", $$v)
                    },
                    expression: "searchData.pkg"
                  }
                },
                _vm._l(_vm.searchpkgs, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.pkg_name, value: item.pkg_mark }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "x-f" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.gameshow,
                expression: "gameshow"
              }
            ],
            staticClass: "item_box"
          },
          [
            _c("div", { staticClass: "box_header" }, [
              _c("div", { staticClass: "titles" }, [
                _vm._v(_vm._s(_vm.$t("game")))
              ])
            ]),
            _c(
              "el-table",
              {
                staticClass: "table_box",
                attrs: {
                  "highlight-current-row": "",
                  data: _vm.gameList,
                  height: "100"
                },
                on: {
                  "row-click": function($event) {
                    return _vm.gameClick($event, false)
                  }
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "game_name",
                    label: _vm.$t("gameName"),
                    align: "center"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "game_mark",
                    label: _vm.$t("gameIdentifier"),
                    align: "center"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.plshow,
                expression: "plshow"
              }
            ],
            staticClass: "item_box"
          },
          [
            _c("div", { staticClass: "box_header" }, [
              _c("div", { staticClass: "titles" }, [
                _vm._v(_vm._s(_vm.$t("platform")))
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.canshow == false && _vm.pkgshow == false,
                      expression: "canshow == false && pkgshow == false"
                    }
                  ]
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", round: "" },
                      on: { click: _vm.addplatId }
                    },
                    [_vm._v(_vm._s(_vm.$t("setRelation")))]
                  )
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticClass: "table_box",
                attrs: {
                  "highlight-current-row": "",
                  height: "100",
                  data: _vm.platformList
                },
                on: {
                  "row-click": function($event) {
                    return _vm.platformClick($event, false)
                  },
                  "selection-change": _vm.selectionChange,
                  toggleRowSelection: _vm.handleSelectionChange
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    label: _vm.$t("relation"),
                    width: "55"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "platform_name",
                    label: _vm.$t("platformName"),
                    align: "center"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "platform_mark",
                    label: _vm.$t("platformMark"),
                    align: "center"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.canshow,
                expression: "canshow"
              }
            ],
            staticClass: "item_box"
          },
          [
            _c("div", { staticClass: "box_header" }, [
              _c("div", { staticClass: "titles" }, [
                _vm._v(_vm._s(_vm.$t("channel")))
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pkgshow == false,
                      expression: "pkgshow == false"
                    }
                  ]
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", round: "" },
                      on: { click: _vm.addplatId }
                    },
                    [_vm._v(_vm._s(_vm.$t("setRelation")))]
                  )
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                ref: "multipleTable2",
                staticClass: "table_box",
                attrs: {
                  "highlight-current-row": "",
                  height: "100",
                  data: _vm.channelList
                },
                on: {
                  "row-click": function($event) {
                    return _vm.channelClick($event, false)
                  },
                  "selection-change": _vm.selectionChange1,
                  toggleRowSelection: _vm.handleSelectionChange
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    label: _vm.$t("relation"),
                    width: "55"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "channel_name",
                    label: _vm.$t("channelName"),
                    align: "center"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "channel_mark",
                    label: _vm.$t("channelIdentifier"),
                    align: "center"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pkgshow,
                expression: "pkgshow"
              }
            ],
            staticClass: "item_box"
          },
          [
            _c("div", { staticClass: "box_header" }, [
              _c("div", { staticClass: "titles" }, [
                _vm._v(_vm._s(_vm.$t("pkg")))
              ]),
              _c(
                "div",
                [
                  _c("el-switch", {
                    attrs: {
                      "active-text": _vm.$t("bound"),
                      "inactive-text": _vm.$t("unbound"),
                      "active-color": "#13ce66"
                    },
                    on: {
                      change: function($event) {
                        return _vm.filterPkgList($event)
                      }
                    },
                    model: {
                      value: _vm.isband,
                      callback: function($$v) {
                        _vm.isband = $$v
                      },
                      expression: "isband"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "", size: "mini" },
                      on: { click: _vm.addplatId }
                    },
                    [_vm._v(_vm._s(_vm.$t("setRelation")))]
                  )
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                ref: "multipleTable3",
                staticClass: "table_box",
                attrs: {
                  "highlight-current-row": "",
                  data: _vm.pkgList,
                  height: "100"
                },
                on: { "selection-change": _vm.selectionChange2 }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    label: _vm.$t("relation"),
                    width: "55"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "pkg_name",
                    label: _vm.$t("pkgName"),
                    align: "center"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "pkg_mark",
                    label: _vm.$t("pkgMark"),
                    align: "center"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }